import React from "react";
import { useMetadata } from "../contexts/MetadataContext";
import { Subdivision } from "../types/Subdivision";

type SubdivisionAbbreviationProps = {
  name: string;
  countryId: number;
};

export const SubdivisionAbbreviation: React.FC<SubdivisionAbbreviationProps> = ({ name, countryId }) => {
  const { subdivisions } = useMetadata();

  const getSubdivision = (): string => {
    const subdivision: Subdivision | undefined = subdivisions.find(
      (subdivision) => subdivision.name === name && subdivision.countryId === countryId,
    );
    return subdivision ? subdivision.code : "";
  };

  return <>{getSubdivision()}</>;
};
